import axios from 'axios'
import { getApiBaseUrl } from '../../../utils/apiConfig'
import { getStorageValues } from '../../../shared/CommonFunctions'

/**
 * Public URL for inline PDF (e.g. window.open). Same query shape as sales bill PDF.
 */
export function buildLoanApplicationPdfUrl(financeRegisterId) {
  const id = Number(financeRegisterId)
  if (!Number.isFinite(id) || id <= 0) return ''
  const userId = getStorageValues('userId')
  const companyId = process.env.REACT_APP_COMPANY_ID || '1'
  const base = getApiBaseUrl()
  return `${base}/financeregister/loan-application/pdf?FinanceRegisterId=${encodeURIComponent(
    id
  )}&UserId=${encodeURIComponent(userId || '')}&CompanyId=${encodeURIComponent(companyId)}`
}

function authHeaders() {
  const token = getStorageValues('token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i])
  }
  return window.btoa(binary)
}

/**
 * Fetches the server-rendered loan application PDF for attachments / preview.
 */
export async function fetchLoanApplicationPdfAttachment(financeRegisterId, salesNumber) {
  const url = buildLoanApplicationPdfUrl(financeRegisterId)
  if (!url) {
    throw new Error('Invalid FinanceRegisterId')
  }
  const res = await axios.get(url, {
    responseType: 'arraybuffer',
    headers: { ...authHeaders() },
  })
  const base64 = arrayBufferToBase64(res.data)
  const filename = `LoanApplication-${salesNumber || financeRegisterId}.pdf`
  return { filename, base64, dataUri: `data:application/pdf;base64,${base64}` }
}
